import { render, staticRenderFns } from "./Auth.vue?vue&type=template&id=bd4e0cf6&scoped=true"
import script from "./Auth.vue?vue&type=script&lang=ts"
export * from "./Auth.vue?vue&type=script&lang=ts"
import style0 from "./Auth.vue?vue&type=style&index=0&id=bd4e0cf6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4e0cf6",
  null
  
)

export default component.exports